module.exports = __webpack_public_path__ + "img/qrCode.e9bb02ba.png";